import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme, { width }: { width?: string }) => ({
    rightContent: {
        width: rem(544),
        height: "inherit",
        position: "sticky",
        top: rem(60),
    },
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: theme.spacing.xl,
        width: width ? width : "100%",

        "& > *": {
            color: "inherit",
            fontFeatureSettings: "inherit",
            fontFamily: "inherit",
            fontSize: "inherit",
            fontStyle: "inherit",
            fontWeight: "inherit",
            lineHeight: "inherit",
            display: "inherit",
            flexDirection: "inherit",
            alignItems: "inherit",
            gap: "inherit",
            width: "inherit",
            flex: "inherit",
        },
    },
}))
